import { fromSqlDateTime } from "helpers/Date";
import React, { useContext } from "react";
import { AssignmentContext } from "context/Assignment";

function StaticDateField(props) {
    const { assignment, loading, performingStateChange } =
        useContext(AssignmentContext);

    if (loading || performingStateChange || !assignment) {
        return (
            <div>
                <span className="-mb-1 block text-sm font-medium text-gray-700">
                    {props.label}
                </span>
                <span className="animate-pulse rounded bg-gray-300 text-sm text-gray-300">
                    00/00/0000 00:00:00
                </span>
            </div>
        );
    }

    return (
        <div>
            <span className="-mb-1 block text-sm font-medium text-gray-700">
                {props.label}
            </span>
            <span className="text-sm">
                {assignment[props.field]
                    ? fromSqlDateTime(assignment[props.field]).toFormat("ff")
                    : props.defaultValue}
            </span>
        </div>
    );
}

export default StaticDateField;
